import * as React from 'react';
import { Icon, MediaObject } from '@salesforce/design-system-react';

interface DashboardCardHeaderProps {
	icon: string;
	iconCategory: string;
	subtext: string;
	title: string;
	showHelp?: boolean;
}
const DashboardCardHeader: React.SFC<DashboardCardHeaderProps> = ({ icon, iconCategory, showHelp, subtext, title }) => (
	<MediaObject
		figure={
			<Icon 
				category={iconCategory}
				className="slds-icon_container"
				name={icon}
				style={{
					backgroundColor: '#1A57A2',
					fill: '#fff', 
					padding: icon === 'trail' ? '5px' : '' // WTF SLDS
				}} 
			/>
		}
		body={
			<div>
				<h3 className="slds-text-heading_small">{title}</h3>
				<p className="slds-text-color_weak slds-text-body_small">
					{subtext}
					{showHelp ? 
						<Icon
								assistiveText="Tooltip with icon"
								category="utility"
								className="dashboard_card-tooltip"
								name="info"
								size="x-small"
								style={{fill: '#D8DDE6'}}
						/>
						: null
					}
				</p>
			</div>
		}
	/>	
);

export default DashboardCardHeader;


// WEBPACK FOOTER //
// ./src/Dashboard/CardHeader.tsx